import { useEffect } from 'react';
import { useAudio } from '../context/AudioContext';

const useMediaDetection = () => {
  const { pauseForOtherMedia, audioRef } = useAudio();

  useEffect(() => {
    const handleMediaPlay = (event) => {
      const target = event.target;
      
      // Check if it's an audio or video element, but not our background music
      if ((target.tagName === 'AUDIO' || target.tagName === 'VIDEO') && 
          target !== audioRef.current) {
        pauseForOtherMedia();
      }
    };

    const handleIframeActivity = () => {
      // Detect YouTube iframe interactions (like autoplay)
      const iframes = document.querySelectorAll('iframe[src*="youtube"]');
      iframes.forEach(iframe => {
        // If iframe has autoplay in src, pause background music
        if (iframe.src.includes('autoplay=1')) {
          pauseForOtherMedia();
        }
      });
    };

    // Listen for play events on all media elements
    document.addEventListener('play', handleMediaPlay, true);
    
    // Check for YouTube iframes periodically
    const iframeCheck = setInterval(handleIframeActivity, 1000);
    
    // Also check when new elements are added to the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'IFRAME' && node.src && node.src.includes('youtube')) {
              handleIframeActivity();
            }
            // Check if any child elements are media
            const mediaElements = node.querySelectorAll?.('audio, video, iframe[src*="youtube"]');
            if (mediaElements?.length > 0) {
              handleIframeActivity();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      document.removeEventListener('play', handleMediaPlay, true);
      clearInterval(iframeCheck);
      observer.disconnect();
    };
  }, [pauseForOtherMedia, audioRef]);
};

export default useMediaDetection; 